import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { editGroup } from '../actions/GroupMenuActions';
import { IGroupInfo } from '../models/IGroupInfo';

export const GroupEditAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.EditGroup,
  translateName: Messages.editGroup_action,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    return FeatureFlags.editGroupRedesignEnabled
    && targetItems.length === 1
    && isLocalGroup(targetItems[0]);
  },
  isClickable: (availableActions: {}, targetItems: {}, state: AppState) => SessionUserSelectors.canManageUsers(state),
  createReduxAction: (targetItems: IGroupInfo[]) => editGroup(targetItems[0])
};

function isLocalGroup(group: IGroupInfo): boolean {
  return (group.domainName === undefined || group.domainName === 'local');
}